var _VECTOR_TYPE_TESTS;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import has from 'lodash/has';
import kebabCase from 'lodash/kebabCase';
import { VECTOR_IMAGE_ICON, VECTOR_IMAGE_BRAND, VECTOR_IMAGE_PAYMENT } from '../vectorImage/constants';
var VECTOR_TYPE_TESTS = (_VECTOR_TYPE_TESTS = {}, _defineProperty(_VECTOR_TYPE_TESTS, VECTOR_IMAGE_BRAND, function (name) {
  return name.includes("-".concat(VECTOR_IMAGE_BRAND));
}), _defineProperty(_VECTOR_TYPE_TESTS, VECTOR_IMAGE_PAYMENT, function (name) {
  return name.includes("-".concat(VECTOR_IMAGE_PAYMENT));
}), _VECTOR_TYPE_TESTS);
var SVG_COMPONENT_NAME_MATCH = /^(.+)-svg$/;
/**
 * Formats name by kebab-casing and then stripping off starting "svg-"
 * @param {string} svgComponentName PascalCase SVG component name
 * @returns {string} formatted named
 */

var formatSvgComponentName = function formatSvgComponentName(svgComponentName) {
  var kebabCaseName = kebabCase(svgComponentName);

  var _kebabCaseName$match = kebabCaseName.match(SVG_COMPONENT_NAME_MATCH),
      _kebabCaseName$match2 = _slicedToArray(_kebabCaseName$match, 2),
      strippedName = _kebabCaseName$match2[1];

  return strippedName;
};
/**
 * Whether or not the specified matchers match the specified icon type
 * @param {import('react').ReactElement|string} iconType Icon type
 * @param {(svgComponentName: string) => boolean} svgNameMatcher Matcher when iconType is an SVG Component
 * @returns {boolean}
 */


export var iconNameMatches = function iconNameMatches(iconType, svgNameMatcher) {
  return has(iconType, 'type.displayName') && svgNameMatcher(formatSvgComponentName(iconType.type.displayName));
};
/**
 * Gets the type of vector image based on the specified icon type
 * (NOTE: This is only intended for icons, not graphics or illustrations)
 * @param {import('react').ReactElement} iconType Icon type
 * @returns {'icon'|'brand'|'payment'}
 */

export var getIconVectorType = function getIconVectorType(iconType) {
  var foundVectorType = Object.keys(VECTOR_TYPE_TESTS).find(function (vectorType) {
    var svgTest = VECTOR_TYPE_TESTS[vectorType];
    return iconNameMatches(iconType, svgTest);
  });
  return foundVectorType || VECTOR_IMAGE_ICON;
};